import { logInfo } from 'src/utils/logger';

var UserInfoFactory = require('../../../../factory/user-info');

module.exports = Backbone.View.extend({
  initialize: function () {
    _.bindAll(this, 'requestSize', 'downloadPdf', 'goToPrintTemplates');
    var tool = INKIVE.Tool.getInstance();
    this.canvas = tool.editor.canvas;

    $('a[data-action="request-size"]').on('click', this.requestSize);
    $('a[data-action="resize-design"]').on('click', this.resizeDesign);
    $('a[data-action="explore-templates"]').on('click', this.goToPrintTemplates);
    $('a[data-action="download-pdf"]').on('click', this.downloadPdf);
  },

  requestSize: function (event) {
    event.preventDefault();
    var element = event.currentTarget;
    var size = INKIVE.FormatFactory.getCurrentSize();
    var projectId = INKIVE.C.BOOK.id;

    element.style.display = 'none';
    _loadingToggle(element);

    UserInfoFactory.get().then(_.bind(function (user) {
      var request = new XMLHttpRequest();
      var authorization = 'Basic ' + btoa(user['credentials']['token'] + ':' + user['credentials']['hash']);
      var endpoint = INKIVE.C.BASE_URL
        + 'untidy-api/request-size';
      var params = 'width=' + size.width + '&height=' + size.height;
      params += '&unit=' + size.unit + '&projectId=' + projectId;

      request.open('POST', endpoint);
      request.setRequestHeader('Authorization', authorization);
      request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

      request.onload = function () {
        var success = element.parentNode.querySelector('.request-success');
        if (success) {
          success.style.display = 'flex';
        }

        _loadingToggle(element);
      };
      request.send(params);
    }, this));

    function _loadingToggle (sibling) {
      var loading = sibling.parentNode.querySelector('.request-loading');
      var display = loading.style.display;
      loading.style.display = (display === 'none' || display === '') ? 'block' : 'none';
    }
  },

  downloadPdf: function (event) {
    event.preventDefault();

    var startPage = 1;
    var endPage = INKIVE.C.BOOK.num_pages;
    var alert = INKIVE.Modal.alertMessage(INKIVE.TemplatesHelper('alert_bold', {
      message: 'modal.alert.preparing_file'
    }), {
      skip: false,
      loader: true
    });

    var opts = $.extend({
      format: 'pdf',
      contentW: this.canvas.contentW,
      contentH: this.canvas.contentH,
      baseUrl: INKIVE.C.BASE_URL,
      staticUrl: INKIVE.C.STATIC_URL,
      getUrlResponse: !INKIVE.C.IS_MOBILE
    }, opts);

    var params = {
      book_id: INKIVE.C.BOOK.id,
      forced_transparency: 'n',
      bleed: 'y',
      bleed_type: 'auto',
      bleed_unit: INKIVE.C.BLEED_VALUES.bleedUnit || 'px',
      cutmarks: 'n',
      is_zip: 'n',
      cmyk: 'y',
      has_filter: 'n',
      quality: 'print',
      start_page: startPage,
      end_page: endPage,
      width: opts.contentW,
      height: opts.contentH,
      format: opts.format,
      is_outline: 'n'
    };

    const book = INKIVE.C.BOOK || {};
    logInfo('Print Bleed Info: orderPrintFallback -> downloadPdf()', { params, opts, book });

    INKIVE.EditorFacade.handle('page', 'save').then(function () {
      INKIVE.Helpers.DownloadProcedure.download(function (url) {
        url && INKIVE.Helpers.saveToDisk(url);
        alert.close();
      }, opts, params);
    }, function () {
      alert.close();
    });
  },

  goToPrintTemplates: function (event) {
    event.preventDefault();
    // Replicate action of clicking on the back button
    const backToCreate = $('.menus button[data-action="back-create"]');

    INKIVE.EditorFacade.handle('close', {
      confirm_draft: true,
      back_to_create: !!backToCreate.length
    });
  },

  resizeDesign: function (event) {
    $('.ui-dropdown-content').hide();
    $('header').find('[data-action=resize]').trigger('click');
  }
});
